import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_text_align-center",
  "use": "lc_text_align-center-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_text_align-center\">\r\n<path d=\"M870.4 768H153.6a51.2 51.2 0 0 0 0 102.4h716.8a51.2 51.2 0 0 0 0-102.4z m0-614.4H153.6a51.2 51.2 0 0 0 0 102.4h716.8a51.2 51.2 0 0 0 0-102.4z m-153.6 307.2H307.2a51.2 51.2 0 0 0 0 102.4h409.6a51.2 51.2 0 0 0 0-102.4z\" p-id=\"3475\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol